/* eslint-disable no-bitwise */
import _ from 'lodash';
export function enumHasFlag(enumValue, flag) {
    if (flag === undefined) {
        console.log('FLAG undefined');
    }
    if (enumValue === undefined) {
        console.log('enumValue undefined');
    }
    return Number(BigInt(enumValue) & BigInt(flag)) === flag;
}
export function enumSetFlag(enumValue, flag) {
    return Number(BigInt(enumValue) | BigInt(flag));
}
export function enumSetFlags(enumValue, flags) {
    return Number(BigInt(enumValue) | BigInt(saveReduceOr(flags)));
}
/**
 * Only removes the given flags, if they are set
 * 1010 0101 => Enum value (165)
 * 0001 0101 => Flag(s) (21)
 * =========
 * 1010 0000 => Result (160)
 * @param enumValue
 * @param flag
 * @returns
 */
export function enumRemoveFlag(enumValue, flag) {
    return enumValue - Number(BigInt(enumValue) & BigInt(flag));
}
export function enumRemoveFlags(enumValue, flags) {
    return enumValue - Number(BigInt(enumValue) & BigInt(saveReduceOr(flags)));
}
export function getValuesOfEnum(enumeration, includeZero) {
    return Object.keys(enumeration)
        .filter(function (key) { return !isNaN(key) && (includeZero || key > 0); })
        .map(function (key) { return parseInt(key); });
}
export function getKeysOfEnum(enumeration) {
    return Object.keys(enumeration).filter(function (key) { return isNaN(key); });
}
function saveReduceOr(flags) {
    if (!flags.length) {
        return 0;
    }
    return flags.reduce(function (prev, current) {
        return Number(BigInt(prev) | BigInt(current));
    });
}
export function getValueOfEnumKey(enumeration, enumKey) {
    return getValueOfEnumKeyResolver(enumeration)(enumKey);
}
export function getValueOfEnumKeyResolver(enumeration) {
    var enumKeys = getKeysOfEnum(enumeration);
    var enumValues = getValuesOfEnum(enumeration, true);
    return function (enumKey) {
        if (_.isArray(enumKey)) {
            return _.sum(enumKey.map(function (key) { return enumValues[enumKeys.indexOf(key)]; }));
        }
        var index = enumKeys.indexOf(enumKey);
        return enumValues[index];
    };
}
//# sourceMappingURL=EnumHelpers.js.map